<template>
  <div>
    <!-- <div style="margin-bottom: 50px;color: #409eff;">
      分销会员申请列表，申请审核通过后即可成为分销会员。
    </div> -->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="id"  align="center" label="ID" width="50">
      </el-table-column>
      <el-table-column prop="name" align="center" label="姓名" width="120">
      </el-table-column>
      <el-table-column prop="user.nickName" align="center" label="昵称" width="120">
      </el-table-column>
      <el-table-column label="头像" align="center" width="150">
        <template slot-scope="scope" v-if="scope.row.user">
          <img v-img-url="scope.row.user.avatarUrl" width="50px" height="50px" />
        </template>
      </el-table-column>
      <el-table-column prop="is_waiter" align="center" label="推广人类型" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.is_waiter == 1 ? "技师" : "用户" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="推广人手机号" width="150">
      </el-table-column>
      <el-table-column prop="reason" align="center" label="推广原因">
      </el-table-column>
      <el-table-column prop="reject_reason" align="center" label="审核原因">
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="申请时间" width="150"> </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="220">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status!=2" type="primary" size="small" @click="editClick(scope.row)">审核</el-button>
          <el-button v-else :disabled="true" type="primary" size="small" @click="editClick(scope.row)">审核通过</el-button>
          <el-button type="danger" size="small" @click="delClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
    <Review v-if="open_review" :open_edit="open_review" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Review>
  </div>
</template>

<script>
import Review from "./review.vue";
import PromotionApi from "@/api/promotion.js";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Review
  },
  data() {
    return {
      userModel: {},
      open_review: false,
      activeName: "first",
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 1,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: "",
        mobile: ""
      },
      options: [
        {
          value: "2",
          label: "审核通过"
        },
        {
          value: "3",
          label: "审核拒绝"
        },
        {
          value: "1",
          label: "待审核"
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      PromotionApi.applyList(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*删除*/
    delClick(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PromotionApi.applyDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_review = e.openDialog;
        if (e.type == "success") {
        }
      }
    },
    /*打开审核*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_review = true;
    }
  }
};
</script>
<style lang="scss">
.grid-content {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 80%;
  margin-bottom: 50px;
  margin-top: 40px;
  img {
    margin-right: 40px;
  }
  p {
    color: rgba($color: #000000, $alpha: 0.6);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/apply/index.vue